/*
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-06-29 15:06:34
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-11 18:58:04
 * @FilePath: \mes-web\src\store\modules\equipStore.js
 * @Description: 设备显示中心
 */
import Vue from "vue";
import { getEquipListApi, equipStatApi } from "@/api/em/monitorApi";

import store from "@/store/store";
const equipStore = {
  state: {
    allequip: [],
    pindex: 0,
    psize: 16,
    status: 0,
    workshopid: null,
    stats: {
      total: 0,
      running: 0,
      alarm: 0,
      standby: 0,
      offline: 0
    }
  },
  mutations: {
    SET_ALL_EQUIP: (state, data) => {
      Vue.set(state, "allequip", data);
    },
    SET_PINDEX: (state, data) => {
      Vue.set(state, 'pindex', data)
    },
    SET_STATUS: (state, data) => {
      Vue.set(state, 'status', data)
    },
    SET_SHOPID: (state, data) => {
      Vue.set(state, 'workshopid', data)
    },
    SET_STATS: (state, data) => {
      Object.assign(state.stats, data)
    }
  },

  actions: {
    getAllEquips ({ commit, state }) {
      return new Promise((resolve, reject) => {
        equipStatApi({ workshopid: state.workshopid }).then((res) => {
          commit('SET_STATS', res.data)
        })
        getEquipListApi({ pindex: 1, psize: 100, status: state.status, workshopid: state.workshopid }).then(res => {

          if (!res.errno)
            commit('SET_ALL_EQUIP', res.data.list)
          resolve(res)
        })
      })
    },

    setPindex ({ commit, state }, data) {
      return new Promise((resolve, reject) => {

        if (state.allequip.length <= state.psize || data * state.psize >= state.allequip.length) {
          commit('SET_PINDEX', 0)
          resolve(0)
        } else {
          commit('SET_PINDEX', data)
          resolve(data)
        }

      })
    },

    setStatus ({ commit, state }, data) {
      return new Promise(async (resolve, reject) => {
        if (state.status == data) {
          commit('SET_STATUS', 0)
        } else {
          commit('SET_STATUS', data)
        }
        await store.dispatch('getAllEquips')
        resolve(state.status)
      })
    },

    setShopid ({ commit, state }, data) {
      return new Promise(async (resolve, reject) => {
        // console.log(data, 'sfsfs');
        if (state.workshopid == data) {
          commit('SET_SHOPID', 0)
        } else {
          commit('SET_SHOPID', data)
        }
        await store.dispatch('getAllEquips')
        resolve(state.status)
      })
    }

  }

}

export default equipStore